const testUtilActions = {
	TEST_UTIL_CLEAR_STATE: 'TEST_UTIL_CLEAR_STATE',
	/** ONLY to be used in tests for reseting reducers to initial state */
	clearState: () => ({ type: testUtilActions.TEST_UTIL_CLEAR_STATE }),
};

export default testUtilActions;
